import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SolicitanteService } from '../../services/solicitante/solicitante.service';
import { Solicitante } from '../../models/solictante';
import { MatStepper } from '@angular/material/stepper';
// el motovp de esat declaracin es para accesar a los prcedimeitos dle miso
import { PescadoresComponent } from '../pescadores/pescadores.component';



@Component({
  selector: 'app-solicitantes',
  templateUrl: './solicitantes.component.html',
  styleUrls: ['./solicitantes.component.css']
})
export class SolicitantesComponent implements OnInit {

  @Output() valueChangeSteppe = new EventEmitter();

  @ViewChild('accionboton', {static: false}) accionboton: ElementRef;
  @ViewChild('linear', {static: true}) private myStepper: MatStepper;





  show = false;
  modoEdicion: boolean;


  constructor(
    private _solicitanteService: SolicitanteService
  ) { }

  formasolicitante: FormGroup;

  sonIguales(campo1: string, campo2: string) {

    return (group: FormGroup) => {
      const email1 = group.controls[campo1].value;
      const email2 = group.controls[campo2].value;

      if (email1 === email2) {
        return null;
      }

      return {
        son_iguales: true
      };

    };
  }






ngOnInit() {

  this.formasolicitante = new FormGroup({
    nombre: new FormControl(null, Validators.required),
    email: new FormControl(null, [Validators.required, Validators.email]),
    email2: new FormControl(null, [Validators.required, Validators.email]),
   telefono: new FormControl('')
  }, { validators: this.sonIguales('email', 'email2') });


}



registrarSolicitante() {



  if ( this.formasolicitante.invalid) {

    return;
  }

  this.show = true;

  const solicitante = new Solicitante(
    this.formasolicitante.value.nombre,
    this.formasolicitante.value.email,
    this.formasolicitante.value.telefono,
    null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, 'PUBLICO'
  );


  if (!this.modoEdicion) {
   this.crearSolicitantes (solicitante);
   // this.accionboton.nativeElement.click();



   // this.inicializacaptura();
 } else {
   this.editarSolicitantes(solicitante);

  }





  // @ViewChild('updateinformation') boton: ElementRef;



  // simularClick() {
  //     let boton: HTMLElement = this.updateinformation.nativeElement as HTMLElement;
  //     boton.click();
  // }



}








valueChanged() { // You can give any function name
  this.valueChangeSteppe.emit(true);
}


crearSolicitantes( solicitante: Solicitante) {
  this._solicitanteService.crearSolicitante( solicitante )
.subscribe ( resp => {
  this.valueChanged(); // esta variable permite activar el siguiente paso del stepper
  this.modoEdicion = true;  // este vakor es para determinar cuando es nuevo regustro y cuando es para editarlo
  this.show = false; // este es el modal false equivale a desaparece
  // this.goForward();

});
}


editarSolicitantes( solicitante: Solicitante) {
  this._solicitanteService.regrabarSolicitante( solicitante )
  .subscribe ( resp => {
    this.valueChanged(); // esta variable permite activar el siguiente paso del stepper
    this.modoEdicion = true;
    this.show = false;
   // console.log ( resp );
  });
}




goForward() {

  this.myStepper.selectedIndex = 2;
}

// inicializacaptura() {
  // this.pescadores.Inicializadesplieguetablas();
 // }


}
